import { compiler } from 'markdown-to-jsx'
import { renderToString } from 'react-dom/server'

import { docxComponents } from 'components/ReactMarkdown/consts/docxComponents'

// DOCX export variant: same markdown → HTML, but with inline-style overrides
// instead of Tailwind classNames (html-to-docx has no CSS cascade engine).
export const getHtmlStringForDocx = (markdown: string) =>
  renderToString(compiler(markdown, { overrides: docxComponents }))
